import React, { useRef, useState } from "react";
import { Button, Input } from "reactstrap";
import { QRCodeCanvas } from "qrcode.react";

const QrCodeGenerator = () => {
  const [text, setText] = useState("");
  const [generatedText, setGeneratedText] = useState("");
  const qrWrapperRef = useRef(null);

  const handleGenerate = () => {
    const trimmedText = text.trim();
    setGeneratedText(trimmedText);
  };

  const handleDownload = () => {
    const canvas = qrWrapperRef.current?.querySelector("canvas");

    if (!canvas) {
      return;
    }

    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    const downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "qr-code.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const handleReset = () => {
    setText("");
    setGeneratedText("");
  };

  return (
    <div className="my-4">
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6">
          <div
            className="bg-white p-4 rounded-2"
            style={{ boxShadow: "4px 4px 18px rgba(0,0,0,0.15)" }}
          >
            <h5 className="mb-3 text-dark">QR Code Generator</h5>

            <label className="form-label text-dark">Text to encode</label>
            <Input
              type="text"
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="Enter text or URL"
            />

            <Button
              className="mt-3"
              color="primary"
              onClick={handleGenerate}
              disabled={!text.trim()}
            >
              Generate QR Code
            </Button>

            {generatedText && (
              <div className="text-center mt-4" ref={qrWrapperRef}>
                <QRCodeCanvas
                  value={generatedText}
                  size={220}
                  level="H"
                  includeMargin={true}
                />

                <div>
                  <Button
                    className="mt-3"
                    color="success"
                    onClick={handleDownload}
                  >
                    Download QR Code
                  </Button>
                </div>
                <div>
                  <Button
                    className="mt-3"
                    color="danger"
                    onClick={handleReset}
                  >
                    Reset
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QrCodeGenerator;
